import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../../customHooks/usePatchHook";
import useGetHook from "../../../customHooks/useGetHook";

const EditReferenceTypeComponent = loadable(
  () => import("../../../components/Settings/ReferenceType/EditReferenceType")
);
const EditReferenceType = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: ["reference-type"],
    url: `${APIS.REFERENCE_TYPE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["reference-type"],
    navigateURL: "/reference-type",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.REFERENCE_TYPE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Reference Type</span>
      </div>
      <EditReferenceTypeComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditReferenceType;
